import { Box } from 'braid-design-system';
import React, { Fragment } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { PAGE_ID_CLASSIFY, PAGE_ID_WRITE } from 'src/app/constants/pageUid';
import { PricePanel } from 'src/app/views/components/PricePanel';
import { WorkFromHomeMessage } from 'src/app/views/components/WorkFromHomeMessage';
import type AppState from 'src/types/appState';

import * as styles from './index.css';

export const AsideSection = () => {
  const { hidePrice, pageId } = useSelector(
    (state: AppState) => ({
      hidePrice: state.session.hirerAccount?.hidePrice,
      pageId: state.session.pageId,
    }),
    shallowEqual,
  );

  return (
    <Fragment>
      {pageId === PAGE_ID_CLASSIFY && !hidePrice && (
        <Box paddingLeft={['none', 'large']} className={styles.pricePanel}>
          <PricePanel />
        </Box>
      )}
      {pageId === PAGE_ID_WRITE && (
        <Box paddingLeft={['none', 'large']} className={styles.aside}>
          <WorkFromHomeMessage />
        </Box>
      )}
    </Fragment>
  );
};
